import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './services/AuthContext';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Login from './pages/Auth/Login';
import './App.css';

// Lazy load components for better performance (optional)
const Dashboard = React.lazy(() => import('./pages/Dashboard/Dashboard'));
const ProductsPage = React.lazy(() => import('./pages/Products/ProductsPage'));
const DeliveryChallanPage = React.lazy(() => import('./pages/DeliveryChallan/DeliveryChallanPage'));
const Reports = React.lazy(() => import('./pages/Reports/Reports'));
const UsersPage = React.lazy(() => import('./pages/UsersPage/UsersPage'));
const SearchPage = React.lazy(() => import('./pages/SearchPage/SearchPage'));
const Profile = React.lazy(() => import('./pages/Profile/Profile'));
const HelpSupportPage = React.lazy(() => import('./pages/HelpSupport/HelpSupportPage'));

// Protected Layout component
const ProtectedLayout = ({ children }) => (
  <ProtectedRoute>
    <Layout>
      <React.Suspense fallback={<div>Loading...</div>}>
        {children}
      </React.Suspense>
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route path="/" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
            <Route path="/products" element={<ProtectedLayout><ProductsPage /></ProtectedLayout>} />
            <Route path="/delivery" element={<ProtectedLayout><DeliveryChallanPage /></ProtectedLayout>} />
            <Route path="/reports" element={<ProtectedLayout><Reports /></ProtectedLayout>} />
            <Route path="/users" element={<ProtectedLayout><UsersPage /></ProtectedLayout>} />
            <Route path="/search" element={<ProtectedLayout><SearchPage /></ProtectedLayout>} />
            <Route path="/profile" element={<ProtectedLayout><Profile /></ProtectedLayout>} />
            <Route path="/help-support" element={<ProtectedLayout><HelpSupportPage /></ProtectedLayout>} />
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;